export default "__VITE_ASSET__f03c60ff__"